import { createChange } from '@diagram/model/change.factory';
import { ChangeModel, Status } from '@diagram/model/change.model';
import { NodeId, NodeModel } from '@diagram/model/node.model';
import { ElementById, ResizePatch } from './store.types';

export const compileResizeChanges = (
  Nodes: NodeModel[] | NodeId[],
  status: Status,
  patch?: ResizePatch
) => {
  return Nodes.map((node) => {
    const { x, y, width, height } = patch || {};

    switch (typeof node) {
      case 'string':
        return createChange('resize', {
          id: node,
          status,
          data: {
            x,
            y,
            width,
            height,
          },
        });
      default:
        return createChange('resize', {
          id: node.id,
          status,
          data: {
            x: x ? x : node.position.x,
            y: y ? y : node.position.y,
            width: width ? width : node.width ?? 100,
            height: height ? height : node.height ?? 100,
          },
        });
    }
  });
};

export const createResizePatch = (
  id: NodeId,
  x: number,
  y: number,
  w: number,
  h: number
): ResizePatch => {
  return {
    id,
    x: x,
    y: y,
    width: w,
    height: h,
  };
};

export const compileResizePatchAndChange = (
  Nodes: NodeId[],
  x: number,
  y: number,
  w: number,
  h: number
): { patches: ResizePatch[]; changes: ChangeModel[] } => {
  const patches: ResizePatch[] = [];
  const changes: ChangeModel[] = [];
  Nodes.forEach((nodeId) => {
    patches.push(createResizePatch(nodeId, x, y, w, h));
    changes.push(
      createChange('resize', {
        id: nodeId,
        type: 'resize',
        status: 'dragging' as Status,
        data: {
          x: x,
          y: y,
          width: w,
          height: h,
        },
      })
    );
  });
  return {
    patches,
    changes,
  };
};

export const toArrayInOrder = (byId: ElementById<NodeModel>): NodeModel[] => {
  return Object.values(byId).sort((a, b) => a.data.index - b.data.index) || [];
};
